import { render, staticRenderFns } from "./PayAsYouGoModal.vue?vue&type=template&id=990e809e&"
import script from "./PayAsYouGoModal.vue?vue&type=script&lang=js&"
export * from "./PayAsYouGoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports